import React from 'react'
import './Report.css'
import TopBar from '../components/TopBar'
import Footer from '../components/Footer'
import D from '../assets/Download.svg'
import R from '../assets/report.webp'
import report1 from '../assets/reports/Khamsa Insurance Financial Report 2022.pdf'

import report2 from '../assets/reports/Khamsa Insurance Financial Report 2023.pdf'
import report3 from '../assets/reports/Khamsa Insurance - 08.04.2025.pdf'

import { motion as m } from "framer-motion";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ErrorModal from '../components/ErrorModal.jsx'

gsap.registerPlugin(useGSAP);

const Report = () => {

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const [showError, setShowError] = useState(false);
    ///landing
    const elRef1 = useRef(null);
    const elRef2 = useRef(null);
    const elRef3 = useRef(null);
    const elRef4 = useRef(null);

    useGSAP(() => {
        // Register the plugin
        gsap.registerPlugin(ScrollTrigger);

        //landing animation for the 'top' section

        gsap.from([elRef1.current, elRef2.current, elRef3.current, elRef4.current], {
            opacity: 0,
            y: "+=50",
            delay: 0.5,
            stagger: 0.25,
            ease: "sine.out",
        });

    }, []);
    return (
        <m.div className="Report"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: .25 }}
        >
            {/* <TopBar /> */}
            <p className="Report-header">{t("Report4")}</p>
            <div className="Report-content">
                <div className="Report-content-element" ref={elRef3}>
                    <img loading="lazy" decoding="async" src={R} alt="" className="Report-content-element-image" />
                    <div className='Report-content-element-bottom'>
                        <div className='Report-content-element-bottom-left'>
                            <p className="Report-content-element-bottom-left-top">{t("Report6")}</p>
                        </div>
                        <button
                            type='button'
                            onClick={() => setShowError(true)}
                            className='Report-content-element-bottom-right Report-content-element-bottom-right-button'
                        >
                            <img loading="lazy" decoding="async" src={D} alt="" className="Report-content-element-bottom-right-image" />
                            <p className="Report-content-element-bottom-right-text">{t("Report3")}</p>
                        </button>
                    </div>
                </div>
                <div className="Report-content-element" ref={elRef4}>
                    <img loading="lazy" decoding="async" src={R} alt="" className="Report-content-element-image" />
                    <div className='Report-content-element-bottom'>
                        <div className='Report-content-element-bottom-left'>
                            <p className="Report-content-element-bottom-left-top">{t("Report5")}</p>
                        </div>
                        <a href={report3} target='_blank' rel='noopener noreferrer' className='Report-content-element-bottom-right'>
                            <img loading="lazy" decoding="async" src={D} alt="" className="Report-content-element-bottom-right-image" />
                            <p  className="Report-content-element-bottom-right-text">{t("Report3")}</p>
                        </a>
                    </div>
                </div>
                
            </div>
            <div className="Report-content">
                
                <div className="Report-content-element" ref={elRef2}>
                    <img loading="lazy" decoding="async" src={R} alt="" className="Report-content-element-image" />
                    <div className='Report-content-element-bottom'>
                        <div className='Report-content-element-bottom-left'>
                            <p className="Report-content-element-bottom-left-top">{t("Report1")}</p>
                        </div>
                        <a href={report2} target='_blank' rel='noopener noreferrer' className='Report-content-element-bottom-right'>
                            <img loading="lazy" decoding="async" src={D} alt="" className="Report-content-element-bottom-right-image" />
                            <p  className="Report-content-element-bottom-right-text">{t("Report3")}</p>
                        </a>
                    </div>
                </div>
                <div className="Report-content-element" ref={elRef1}>
                    <img loading="lazy" decoding="async" src={R} alt="" className="Report-content-element-image" />
                    <div className='Report-content-element-bottom'>
                        <div className='Report-content-element-bottom-left'>
                            <p className="Report-content-element-bottom-left-top">{t("Report2")}</p>
                        </div>
                        <a href={report1} target='_blank' rel='noopener noreferrer' className='Report-content-element-bottom-right'>
                            <img loading="lazy" decoding="async" src={D} alt="" className="Report-content-element-bottom-right-image" />
                            <p  className="Report-content-element-bottom-right-text">{t("Report3")}</p>
                        </a>
                    </div>
                </div>
            </div>
            <Footer />
            <ErrorModal
                open={showError}
                onClose={() => setShowError(false)}
                title={t('ErrorModalTitle')}
                message={t('ErrorModalMessage')}
            />
        </m.div>
    )
}

export default Report